import React, { forwardRef } from 'react';

const ArrowRight = ({ color = 'var(--icon-subdued)', size = 24, ...rest }) => {
  return (
    <svg {...rest} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="none" />
      <path
        d="M13.7197 8.28033C13.4268 7.98744 13.4268 7.51256 13.7197 7.21967C14.0126 6.92678 14.4874 6.92678 14.7803 7.21967L18.7803 11.2197C19.0732 11.5126 19.0732 11.9874 18.7803 12.2803L14.7803 16.2803C14.4874 16.5732 14.0126 16.5732 13.7197 16.2803C13.4268 15.9874 13.4268 15.5126 13.7197 15.2197L16.4393 12.5H6.75C6.33579 12.5 6 12.1642 6 11.75C6 11.3358 6.33579 11 6.75 11H16.4393L13.7197 8.28033Z"
        fill={color}
      />
    </svg>
  );
};

export default forwardRef(ArrowRight);
